import { constants, typographyStyles } from "@newsela/angelou";

const { colors } = constants;
const { fontSize } = typographyStyles;
const neutral500 = colors.ui.neutral[500];

export const headingCss = {
  color: neutral500,
  ...fontSize.textXS,
  fontWeight: 400,
  letterSpacing: "1px",
  textTransform: "uppercase",
};
